export default (currencySymbol) => ({
    revenue: { symbol: currencySymbol, location: 'pre' },
    spendInLeadingCurrency: { symbol: currencySymbol, location: 'pre' },
    fillRate: { symbol: '%', location: 'post' },
    availabilityRate: { symbol: '%', location: 'post' },
    clickRate: { symbol: '%', location: 'post' },
    completionRate: { symbol: '%', location: 'post' },
    eCPM: { symbol: currencySymbol, location: 'pre' },
    eCPC: { symbol: currencySymbol, location: 'pre' },
    engagedUsersRate: { symbol: '%', location: 'post' },
    engagedCohortUsersRate: { symbol: '%', location: 'post' },
    revenuePerActiveUser: { symbol: '¢', location: 'post' },
    revenuePerEngagedUser: { symbol: '¢', location: 'post' },
    revenuePerCohortUser: { symbol: '¢', location: 'post' },
    averageRevenue: { symbol: '¢', location: 'post' },
    impressionPerFulfillmentRate: { symbol: '%', location: 'post' },
    completionRateImpBased: { symbol: '%', location: 'post' },
    retention: { symbol: '%', location: 'post' },
    engagedUserPerCohortUser: { symbol: '%', location: 'post' },
    revenueSOV: { symbol: '%', location: 'post' },
    renderRate: { symbol: '%', location: 'post' },
    winRate: { symbol: '%', location: 'post' },
    bidRate: { symbol: '%', location: 'post' },
    bidResponseTime: { symbol: 'ms', location: 'post' },
});
